import { render, staticRenderFns } from "./master_awb.vue?vue&type=template&id=31460350&"
import script from "./master_awb.vue?vue&type=script&lang=js&"
export * from "./master_awb.vue?vue&type=script&lang=js&"
import style0 from "./master_awb.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports